const ATTRIBUTION_KEY = 'fg-attribution'

export interface AttributionSnapshot {
  first_utm_source?: string
  first_utm_medium?: string
  first_utm_campaign?: string
  first_utm_content?: string
  first_utm_term?: string
  latest_utm_source?: string
  latest_utm_medium?: string
  latest_utm_campaign?: string
  latest_utm_content?: string
  latest_utm_term?: string
}

const UTM_KEYS: Array<'utm_source' | 'utm_medium' | 'utm_campaign' | 'utm_content' | 'utm_term'> = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
]

function canUseStorage(): boolean {
  return typeof window !== 'undefined' && !!window.localStorage
}

export function captureAttribution(searchParams: URLSearchParams): void {
  if (!canUseStorage()) return

  const updates: Record<string, string> = {}
  for (const key of UTM_KEYS) {
    const value = searchParams.get(key)
    if (value) updates[key] = value
  }
  if (Object.keys(updates).length === 0) return

  const current = getAttributionSnapshot()
  const next: AttributionSnapshot = { ...current }
  for (const [key, value] of Object.entries(updates)) {
    const suffix = key.replace('utm_', '')
    const firstKey = `first_utm_${suffix}` as keyof AttributionSnapshot
    const latestKey = `latest_utm_${suffix}` as keyof AttributionSnapshot
    if (!next[firstKey]) next[firstKey] = value
    next[latestKey] = value
  }
  localStorage.setItem(ATTRIBUTION_KEY, JSON.stringify(next))
}

export function getAttributionSnapshot(): AttributionSnapshot {
  if (!canUseStorage()) return {}
  try {
    const raw = localStorage.getItem(ATTRIBUTION_KEY)
    return raw ? JSON.parse(raw) : {}
  } catch {
    return {}
  }
}
